import React from 'react';

export type BillingPeriod = 'MONTHLY' | 'ANNUAL';

export interface PriceSummaryProps {
  amount: number;
  billingPeriod: BillingPeriod | string;
  planName?: string;
}

const PriceSummary: React.FC<PriceSummaryProps> = ({
  amount,
  billingPeriod,
  planName,
}) => {
  const isAnnual = billingPeriod === 'ANNUAL';

  return (
    <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {planName ? `${planName} - ` : ''}Total to be charged
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-500">
            {isAnnual ? 'Billed annually' : 'Billed monthly'}
          </p>
        </div>
        <p className="text-2xl font-bold text-gray-900 dark:text-white">
          ${amount.toFixed(2)}
        </p>
      </div>
    </div>
  );
};

export default PriceSummary;
